import _ from "lodash";
import { createSelector } from "reselect";

function getSessionFerries(state) {
  return _.get(state.FerrySearchResults, "ferries", []);
}

const getFerriesFilters = (state) => state.FerryFilters;

function getPricesRange(state) {
  const ferries = _.get(state.FerrySearchResults, "ferries", []);
  var minPrice = 0;
  var maxPrice = 0;

  if (!ferries.length) {
    return {
      minPrice,
      maxPrice,
      currency: "",
    };
  }

  minPrice = Math.floor(Math.min(...ferries.map((ferry) => ferry.price.value)));
  maxPrice = Math.ceil(Math.max(...ferries.map((ferry) => ferry.price.value)));

  return {
    minPrice: minPrice,
    maxPrice: maxPrice,
    currency: _.get(ferries, "[0].price.currency", ""),
  };
}

function getAllOperators(state) {
  const ferries = _.get(state.FerrySearchResults, "ferries", []);
  return [
    ...new Set(
      _.flatten(
        ferries.map((ferry) => ferry.legs.map((leg) => leg.operator.name))
      )
    ),
  ].sort((a, b) => a - b);
}

function getFastest(state) {
  const ferries = _.get(state.FerrySearchResults, "ferries", []);
  return Math.min(...ferries.map((ferry) => ferry.legs[0].duration_minutes));
}

function getCheapest(state) {
  const ferries = _.get(state.FerrySearchResults, "ferries", []);
  return Math.min(...ferries.map((ferry) => ferry.price.value));
}

function sortFerries(ferries, order_by) {
  switch (order_by) {
    case "PRD":
      return ferries.sort((a, b) => a.price.value - b.price.value);
    case "PRU":
      return ferries.sort((a, b) => a.price.value - b.price.value).reverse();
    case "DUD":
      return ferries
        .sort(
          (a, b) =>
            _.get(a, "legs.0.duration_minutes", 0) -
            _.get(b, "legs.0.duration_minutes", 0)
        )
        .reverse();
    case "DUU":
      return ferries.sort(
        (a, b) =>
          _.get(a, "legs.0.duration_minutes", 0) -
          _.get(b, "legs.0.duration_minutes", 0)
      );

    default:
      return ferries;
  }
}

// =================== FERRIES SELECTORS =========================
export const getSessionFerriesSelector = createSelector(
  [getSessionFerries],
  (sessionFerries) => sessionFerries
);

export const getFerriesFiltersSelector = createSelector(
  [getFerriesFilters],
  (filters) => filters
);

export const getPricesRangeSelector = createSelector(
  [getPricesRange],
  (pricesRange) => pricesRange
);

export const getOperatorsSelector = createSelector(
  [getAllOperators],
  (operators) => operators
);

export const getFastestSelector = createSelector(
  [getFastest],
  (fastest) => fastest
);

export const getCheapestSelector = createSelector(
  [getCheapest],
  (cheapest) => cheapest
);

// ===============================================================

export const getFilteredSessionFerriesSelector = createSelector(
  [
    getSessionFerriesSelector,
    getFerriesFiltersSelector,
    getPricesRangeSelector,
    getFastestSelector,
    getCheapestSelector,
  ],
  (sessionFerries, filters, pricesRange, fastest, cheapest) => {
    var ferries = _.cloneDeep(sessionFerries);

    const computed_data = { fastest, cheapest };

    if (
      filters.budget[0] > pricesRange.minPrice ||
      filters.budget[1] < pricesRange.maxPrice
    ) {
      ferries = ferries.filter(
        (ferry) =>
          ferry.price.value > filters.budget[0] &&
          ferry.price.value <= filters.budget[1]
      );
    }

    if (filters.operator) {
      ferries = ferries.filter((ferry) =>
        ferry.legs.some((leg) => leg.operator.name === filters.operator)
      );
    }

    return { results: sortFerries(ferries, filters.order_by), computed_data };
  }
);
